import React from 'react';
import { ICostConsumedCards } from './CostConsumedCards.interface';
import { KpiCard } from 'app/components/KpiCard';
import styles from './CostConsumedCards.module.scss';
import { EstimatedCostKpiInfoTooltipContent } from 'app/utils/consts';
import { calculateMonthlyDifference } from 'app/utils';

export const CostConsumedCards: React.FC<ICostConsumedCards> = ({
  currency,
  overallCost,
  overallRequests,
  usageData
}) => {
  const currentMonth = new Date().getMonth() + 1;
  const previousMonth = currentMonth === 1 ? 12 : currentMonth - 1;
  const defaultData = {
    totalRequests: 0,
    totalAmount: 0
  };

  const currentData = usageData[currentMonth] || defaultData;
  const previousData = usageData[previousMonth] || defaultData;

  const requestsDifference = calculateMonthlyDifference(
    currentData.totalRequests,
    previousData.totalRequests
  );
  const costDifference = calculateMonthlyDifference(
    currentData.totalAmount,
    previousData.totalAmount
  );

  return (
    <div className={styles['kpi-cards-container']}>
      <KpiCard
        title="Total interactions"
        mainData={overallRequests}
        percentageDifference={requestsDifference}
      />
      <KpiCard
        title="Estimated cost"
        mainLabel={currency}
        mainData={overallCost.toFixed(2)}
        percentageDifference={costDifference}
        tooltipContent={EstimatedCostKpiInfoTooltipContent}
      />
    </div>
  );
};
